import eventBus from '@utils/bus';
export default {
  name: 'login-confirm',
  props: {},
  data: function data() {
    return {
      popVisible: false
    };
  },
  methods: {
    close: function close() {
      this.popVisible = false;
    },
    handleOk: function handleOk() {
      this.afterConfirmFunc && this.afterConfirmFunc(this);
    }
  },
  mounted: function mounted() {
    var _this = this;
    eventBus.$on('Restore-Login-Confirm', function (afterConfirmFunc) {
      _this.popVisible = true;
      _this.afterConfirmFunc = afterConfirmFunc;
    });
  }
};